import React from 'react';
import Button from '../../../components/ui/Button';
import GlowRing from '../../../components/ui/GlowRing';

const PredictionGaugeCard = ({ client, onPredict, isAnalyzing }) => {
  const stats = client?.stats;
  const adherenceRate = stats?.adherenceRate || 0;
  
  const getAdherenceColor = (rate) => {
    if (rate >= 80) return 'lime';
    if (rate >= 60) return 'cyan';
    if (rate >= 40) return 'orange';
    return 'orange';
  };

  const ringColor = getAdherenceColor(adherenceRate);
  const predictionScore = adherenceRate;
  const confidenceLevel = adherenceRate >= 70 ? 'High' : adherenceRate >= 50 ? 'Medium' : 'Low';

  const neonColors = { lime: '#AAFF00', cyan: '#00D4FF', orange: '#FF6B00' };
  const neonColor = neonColors?.[ringColor];

  return (
    <div className="glass-card p-6 hover:shadow-lg transition-shadow" style={{ borderColor: `${neonColor}22` }}>
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground" style={{ fontFamily: "'Inter Tight', 'Inter', sans-serif" }}>{client?.fullName}</h3>
          <p className="text-sm text-muted-foreground mt-1">
            {client?.fitnessGoals || client?.healthGoals || 'General fitness'}
          </p>
        </div>
        <div className="px-3 py-1 rounded-full text-xs font-medium" style={{ background: `${neonColor}15`, color: neonColor }}>
          {confidenceLevel} Confidence
        </div>
      </div>

      <div className="flex items-center justify-center mb-6">
        <GlowRing
          value={predictionScore}
          max={100}
          color={ringColor}
          size={160}
          strokeWidth={12}
          label="Success Rate"
          unit="%"
          displayValue={`${predictionScore}%`}
          sublabel="Success Rate"
        />
      </div>

      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="text-center">
          <p className="text-xs text-muted-foreground">Adherence</p>
          <p className="text-lg font-semibold font-metric" style={{ color: '#00D4FF' }}>{stats?.adherenceRate}%</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground">Completed</p>
          <p className="text-lg font-semibold font-metric" style={{ color: '#AAFF00' }}>{stats?.completedWorkouts}</p>
        </div>
        <div className="text-center">
          <p className="text-xs text-muted-foreground">Trend</p>
          <p className="text-lg font-semibold text-foreground capitalize">
            {stats?.adherenceTrend === 'improving' ? '📈' : stats?.adherenceTrend === 'declining' ? '📉' : '➡️'}
          </p>
        </div>
      </div>

      <Button
        variant="default"
        className="w-full"
        iconName="Brain"
        onClick={onPredict}
        disabled={isAnalyzing}
      >
        {isAnalyzing ? 'Analyzing...' : 'Generate AI Prediction'}
      </Button>
    </div>
  );
};

export default PredictionGaugeCard;